import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-po-amendment-form',
 
  templateUrl: './add-po-amendment-form.component.html',
  styleUrl: './add-po-amendment-form.component.css'
})
export class AddPoAmendmentFormComponent implements OnInit {
poamendmentForm !: FormGroup;


  commonFields = [
  { key: 'amendmentId', label: 'Amendment ID', type: 'text', required: true, value: 'POA-2025-001' },
  { key: 'originalPoId', label: 'Original PO ID', type: 'text', required: true, value: 'PO-2025-001' },
  { key: 'amendmentDate', label: 'Amendment Date', type: 'date', required: true, value: '2025-10-01' },
  { key: 'amendmentType', label: 'Amendment Type', type: 'text', required: true, value: 'Quantity Change / Item Addition' },
  { key: 'reasonForAmendment', label: 'Reason for Amendment', type: 'text', required: true, value: 'Increased demand' },
  { key: 'revisedQuantity', label: 'Revised Quantity', type: 'text', required: true, value: '600 bags' },
  { key: 'revisedUnitPrice', label: 'Revised Unit Price', type: 'text', required: true, value: '₹360/bag' },
  { key: 'revisedTotalValue', label: 'Revised Total Value', type: 'text', required: true, value: '₹ 300,000' },
  { key: 'approvalStatus', label: 'Approval Status', type: 'text', required: true, value: 'Approved' },
  { key: 'authorizedBy', label: 'Authorized By', type: 'text', required: true, value: 'Procurement Head' }
];

  pickerMap: { [key: string]: MatDatepicker<any> } = {};
  constructor(private fb: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService) { }

 ngOnInit(): void {
  this.poamendmentForm  = this.fb.group({});
  this.commonFields.forEach(field => {
    const validators = field.required ? [Validators.required] : [];
    this.poamendmentForm .addControl(field.key, this.fb.control(field.value || '', validators));
  });
  this.poamendmentForm .reset(this.commonFields);
}



  onSubmit() {
    if (this.poamendmentForm .valid) {
      console.log(this.poamendmentForm .value);
    }
  }
  onReset(): void {
    this.poamendmentForm .reset();
  }


}

